import React, { useEffect } from "react";
import { BASE_URL } from "./../../global";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";
import { Toolbar, TextField, Autocomplete, Modal, Box, useMediaQuery, Grid, Tooltip } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ListWrap from "../commonComponent/listWrap";
import { paginationrowsPerPageOptions } from "../../constants/commonConst";
import moment from "moment";
import { priorityOptions } from "./editTaskMgmt";

const TaskMgmtList = () => {
  const urlPath = useLocation();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client Name");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [totalRows, setTotalRows] = React.useState(0);
  const [taskList, setTaskList] = React.useState([]);
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true");
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [editAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const userType = localStorage.getItem("type");
  const userId = localStorage.getItem("id");

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "";
    let pagination_settings = "";

    // Type 1 & 4 can see all data, others only assigned tasks
    if (userType != 1 && userType != 4) {
      whereConditions += whereConditions.length > 0 ? ` AND tm.assignedUser = ${userId}` : `WHERE tm.assignedUser = ${userId}`;
    }

    if (searchBy !== "" && searchKey !== "") {
      let colName = {
        "Client Name": "c.companyName",
        "SRF Number": "tm.serviceRequestNo",
      }[searchBy];

      if (searchBy === "Priority") {
        whereConditions +=
          whereConditions.length > 0
            ? ` AND tm.Priority = ${searchKey}`
            : `WHERE tm.Priority = ${searchKey}`;
      } else {
        whereConditions +=
          whereConditions.length > 0
            ? ` AND LOWER(${colName}) LIKE LOWER('%${searchKey}%')`
            : `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey}%')`;
      }
    }

    if (!removePagination && rowsPerPage !== -1) {
      pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(page)
        }`;
    }

    let data = {
      query: `SELECT tm.id, tm.serviceRequestNo, tm.Priority, tm.taskStatus, tm.reason, tm.completionDate, tm.status, c.companyName, u.userName AS assignedUserName FROM taskManagement tm LEFT JOIN clients c ON c.id = tm.clientId LEFT JOIN users u ON u.id = tm.assignedUser ${whereConditions} ORDER BY tm.id DESC ${pagination_settings}`,
    };

    if (count) {
      data.query = `SELECT COUNT(*) AS no_of_rows FROM taskManagement tm LEFT JOIN clients c ON c.id = tm.clientId LEFT JOIN users u ON u.id = tm.assignedUser ${whereConditions}`;
    }

    return data;
  };

  const getTotalRows = () => {
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => setTotalRows(res.data[0]?.no_of_rows))
      .catch((err) => console.error("Count fetch error:", err));
  };

  const fetchTaskList = () => {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => setTaskList(res.data || []))
      .catch((err) => console.error("Task list fetch error:", err));
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    fetchTaskList();
    getTotalRows();
  };

  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    setPage(0);
    setSearchBy("Client Name");
    setSearchKey("");
    setSearched(false);
  };

  const handleDelete = (id) => {
    axiosWithToken
      .delete(BASE_URL + `taskManagement/${id}`)
      .then(() => {
        toast("Task is deleted!");
        setTimeout(() => window.location.reload(false), 500);
      })
      .catch((err) => console.error(err));
  };

  const handleStatusUpdate = (id) => {
    axiosWithToken.patch(BASE_URL + `taskManagement/${id}`, { taskStatus: 2, })
      .then(() => {
        toast.success("Task marked as completed!");
        fetchTaskList();
        getTotalRows();
      })
      .catch((err) => console.error(err));
  };


  useEffect(() => {
    if (searched == false) {
      fetchTaskList();
      getTotalRows();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [rowsPerPage, page, searched]);

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };


  const filterSection = () => (
    <Grid container spacing={2} alignItems="center" style={{ padding: "5px 0px" }}>
      <Grid item xs={12} sm={5} md={2} lg={2}>
        <Autocomplete
          sx={{ m: 0, minWidth: 180 }}
          size="small"
          id="combo-box-demo"
          className="Listinputcss"
          value={searchBy}
          options={[
            { key: "clientName", label: "Client Name" },
            { key: "srfNumber", label: "SRF Number" },
            { key: "priority", label: "Priority" },
          ]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(_, newVal) => {
            setSearchBy(newVal);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={2}>
        {searchBy === "Priority" ? (
          <Autocomplete
            sx={{ m: 0, minWidth: 180 }}
            size="small"
            className="Listinputcss"
            options={priorityOptions}
            getOptionLabel={(option) => option.label || ""}
            value={
              priorityOptions.find((p) => p.id === Number(searchKey)) || null
            }
            onChange={(e, value) => {
              setSearchKey(value ? value.id : "");
              setSearched(false);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Priority" />
            )}
          />
        ) : (
          <TextField
            style={{ width: "100%" }}
            label={"Enter " + searchBy}
            size="small"
            className="Listinputcss"
            variant="outlined"
            inputProps={{ autoComplete: "off" }}
            value={searchKey}
            onChange={(e) => {
              setSearchKey(e.target.value);
              setSearched(false);
            }}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={1} textAlign="left">
        <Button
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
            handleFilterClose();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
    </Grid>
  );

  const filterModal = () => {
    return (
    <Modal open={filterModalOpen}>
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 30%)",
          backgroundColor: "white",
          boxShadow: 24,
          padding: "10px",
        }}
      >
        <Button
          variant="contained"
          size="small"
          color="error"
          style={{ float: "right" }}
          onClick={handleFilterClose}
        >
          X
        </Button>
        {filterSection()}
      </Box>
    </Modal>
   );
  };

  return (
    <ListWrap>
      {filterModal()}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          {(userType == 1 || userType == 4) && (
            <Button
              variant="contained"
              size="small"
              component={Link}
              to="/editTaskMgmt/0"
            >
              <b>ADD TASK</b>
            </Button>
          )}
        </Toolbar>
        <Button
          style={{ display: isMobile ? "block" : "none" }}
          onClick={handleFilterOpen}
        >
          <FilterAltIcon />
        </Button>
      </Box>

      {!isMobile && filterSection()}

      <TableContainer sx={{ maxHeight: isMobile ? "75vh" : "65vh" }}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left" style={{ minWidth: 40 }}><b>Sr.No.</b></TableCell>
              <TableCell align="left" style={{ minWidth: 120 }}><b>Client</b></TableCell>
              <TableCell align="left" style={{ minWidth: 100 }}><b>Service Req. No.</b></TableCell>
              <TableCell align="left" style={{ minWidth: 120 }}><b>Priority</b></TableCell>
              <TableCell align="left" style={{ minWidth: 120 }}><b>Assigned To</b></TableCell>
              <TableCell align="left" style={{ minWidth: 110 }}><b>Completion Date</b></TableCell>
              <TableCell align="left" style={{ minWidth: 110 }}><b>Status</b></TableCell>              
              <TableCell align="left" style={{ minWidth: 80 }}><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {taskList?.length > 0 ? (
              taskList.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  <TableCell align="left">{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell align="left">{row.companyName || "-"}</TableCell>
                  <TableCell align="left">{row.serviceRequestNo || "-"}</TableCell>
                  <TableCell align="left">{priorityOptions.find((pr) => pr.id == row.Priority)?.label || "-"}</TableCell>
                  <TableCell align="left">{row.assignedUserName || "-"}</TableCell>
                  <TableCell align="left">
                    {row.completionDate ? moment(row.completionDate).format("YYYY-MM-DD HH:mm") : "-"}
                  </TableCell>
                  <TableCell align="left">{row.taskStatus == 1 ? "Pending" : "Completed" || "-"}</TableCell>
                  <TableCell>
                    <ButtonGroup size="small" aria-label="small button group">
                      {(userType == 1 || userType == 4) && (
                        <>
                          <Tooltip title="Edit Task" placement="top-start">
                            <Button component={Link} to={`/editTaskMgmt/${row.id}`}>
                              <PreviewIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Delete Task" placement="top-start">
                            <Button
                              disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                              onClick={() => {
                                if (window.confirm("Are you sure you want to delete this?"))
                                  handleDelete(row.id);
                              }}
                            >
                              <DeleteIcon
                                style={{
                                  color: !(editAccess?.includes(2) || editAccess?.includes(0))
                                    ? "lightgray"
                                    : "#dc3545",
                                }}
                              />
                            </Button>
                          </Tooltip>
                        </>
                      )}
                      <Tooltip
                        title={row.taskStatus === 2 ? "Task Completed" : "Mark as Completed"}
                        placement="top-start"
                      >
                        <Button
                          disabled={row.taskStatus === 2}
                          onClick={() => {
                            if (
                              window.confirm("Are you sure you want to mark this task as completed?")
                            ) {
                              handleStatusUpdate(row.id);
                            }
                          }}
                        >
                          <CheckCircleIcon
                            style={{
                              color: row.taskStatus === 2 ? "green" : "#1976d2",
                            }}
                          />
                        </Button>
                      </Tooltip>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
      />
    </ListWrap>
  );
};

export default TaskMgmtList;